<style lang="scss" src='./FacilityType.scss' scoped></style>
<template src="./FacilityType.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Placeholder from '@/components/placeholders/Placeholders.vue';
import {
  getFacilityTypes,
  postFacilityTypes,
  editFacilityTypes,
  uploadNewFacilityBackground,
  uploadFacilityBackground
} from '@/api/index';
import i18n from './../../../../i18n';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';

export default {
  name: 'FacilityType',
  extends: SecurityComponent,
  components: {
    Placeholder,
    VueSlider,
  },
  data() {
    return {
      create: true,
      facilityTypesAvailable: [],
      newActive: false,
      editFacility: null,
      facilityNameEnglish: null,
      facilityNameSpanish: null,
      facilityWebBg: null,
      facilityAppBg : null,
      overrideDepth: false,
      maxSliderDepth: 6,
      hasNewWebBg: false,
      hasNewAppBg: false,
      web_image_url: null,
      app_image_url: null,
      tempWebPhoto: {
        file: null,
        name: null,
      },
      tempAppPhoto: {
        file: null,
        name: null,
      },
      loading: false,
    };
  },
  computed: {
  },

  methods: {
    getLabel(item) {
      if(item.i18n.length > 0){
          let text = item.i18n.find((item)=>{
            if(item.language == this.$i18n.locale){
              return item
            }    
          })

          if(text){
            return text.i18n
          }else{
            return item.name
          }
        }else{
          return item.name
        }
    },

    onNewWebBgSelected(ev) {
      const file = ev.target.files[0];
      if (this.G_validateImage(file)) {
        this.tempWebPhoto = {
          file: file,
          name: file.name,
        }
        var reader = new FileReader();
        reader.onloadend = () => {
          this.facilityWebBg = reader.result;
          this.hasNewWebBg = true;
        }
        reader.readAsDataURL(file);
      }
    },

    onNewAppBgSelected(ev) {
      const file = ev.target.files[0];
      if (this.G_validateImage(file)) {
        this.tempAppPhoto = {
          file: file,
          name: file.name,
        }
        var reader = new FileReader();
        reader.onloadend = () => {
          this.facilityAppBg = reader.result;
          this.hasNewAppBg = true;
        }
        reader.readAsDataURL(file);
      }
    },

    showNewFacilityModal() {
      this.newActive = true;
      this.facilityNameSpanish = null;
      this.facilityNameEnglish = null;
      this.facilityWebBg = null;
      this.facilityAppBg = null;
      this.overrideDepth = false;
      this.maxSliderDepth= 6;
      this.hasNewWebBg = false;
      this.hasNewAppBg = false;
      this.web_image_url = null;
      this.app_image_url = null;
      this.$bvModal.show('modal-add-facility')
    },

    showEditFacilityModal(item) {
      this.loading = false;
      this.editFacility = item;
      let itemSpanish = item.i18n.find((item) => item.language == 'es');
      this.facilityNameSpanish = (itemSpanish) ? itemSpanish.i18n : '';
      let itemEnglish = item.i18n.find((item) => item.language == 'en');
      this.facilityNameEnglish = (itemEnglish) ? itemEnglish.i18n : '';
      this.facilityWebBg = item.web_image_url;
      this.facilityAppBg = item.app_image_url;
      this.overrideDepth = item.override_max_depth;
      this.maxSliderDepth = this.overrideDepth ? item.max_depth : 6;
      this.hasNewWebBg = false;
      this.hasNewAppBg = false;
      this.web_image_url = null;
      this.app_image_url = null;
      this.newActive = false;
      this.$bvModal.show('modal-add-facility');
    },
    
    copyName() {
      this.facilityNameSpanish = this.facilityNameEnglish
    },


    async saveFacilityType(){
      this.loading = true;
      if(this.facilityNameSpanish && this.facilityNameEnglish){

        if(this.hasNewWebBg){
          await this.uploadWebBg();
        }

        if(this.hasNewAppBg){
          await this.uploadAppBg();
        }

        let i18nArray =[
          { 
            language: "es",
            i18n: this.facilityNameSpanish
          },{
            language: "en",
            i18n: this.facilityNameEnglish
          }
        ]
        let data = {
          name: this.facilityNameEnglish,
          i18n: i18nArray,
          override_max_depth: this.overrideDepth,
          max_depth: this.overrideDepth ? this.maxSliderDepth : 0,
        };

        if(this.newActive) {

          if(this.hasNewWebBg && this.web_image_url){
            data['web_image_url'] = this.web_image_url;
          }

          if(this.hasNewAppBg && this.app_image_url){
            data['app_image_url'] = this.app_image_url;
          }

          postFacilityTypes(data).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-facility');
          })
        } else {
          editFacilityTypes(data, this.editFacility.type_id).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-facility');
          })
        }

        this.loading = false;
      }
    },

    onAppFileChanged(ev) {
      const file = ev.target.files[0];
      if (this.G_validateImage(file)) {
        this.tempAppPhoto = {
          file: file,
          name: file.name,
        }
        /*var reader = new FileReader();
        reader.onloadend = () => {
          this.userData.photo_url = reader.result;
        }
        reader.readAsDataURL(file);*/
      }
    },

    async uploadWebBg() {
      const formData = new FormData();
      formData.append('web_image', this.tempWebPhoto.file, this.tempWebPhoto.name);

      if(this.newActive) {
        await uploadNewFacilityBackground(formData, 'webbg')
          .then((res) => res.data.data)
          .then((res) => {
            if (res.success) {
              this.web_image_url = res.file_url;
            }
          }).catch(() => {});
      }else{
        await uploadFacilityBackground(this.editFacility.type_id, formData, 'webbg')
          .then((res) => res.data.data)
          .then((res) => {
            if (res.success) {
              this.web_image_url = res.file_url;
            }
          }).catch(() => {});
      }
    },

    async uploadAppBg() {
      const formData = new FormData();
      formData.append('app_image', this.tempAppPhoto.file, this.tempAppPhoto.name);
      
      if(this.newActive) {
        await uploadNewFacilityBackground(formData, 'appbg')
          .then((res) => res.data.data)
          .then((res) => {
            if (res.success) {
              this.app_image_url = res.file_url;
            }
          }).catch(() => {});
      }else{
        await uploadFacilityBackground(this.editFacility.type_id, formData, 'appbg')
          .then((res) => res.data.data)
          .then((res) => {
            if (res.success) {
              this.app_image_url = res.file_url;
            }
          }).catch(() => {});
      }
    },

    async loadData() {
      this.loadAvailableFacilityTypes();
    },

     loadAvailableFacilityTypes() {
      getFacilityTypes().then((resp) => {
        if (resp.facility_types && resp.facility_types.length) {
          this.facilityTypesAvailable = resp.facility_types.map(facility => ({...facility, selected: false}));
        } else {
          this.facilityTypesAvailable = [];
        }
      })
    },
  },
  async mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Facility Type");
      this.$analytics.logEvent("web_settings_facility_type");
    }

    this.loadData();
  },
};

</script>
